import { MDBBtn, MDBContainer, MDBIcon } from "mdb-react-ui-kit";

const Scroll = () => {
  let mybutton;

  window.onscroll = function () {
    mybutton = document.getElementById("btn-back-to-top");
    scrollFunction(mybutton);
  };

  function scrollFunction(mybutton) {
    //if the user scrolled more than 30% of the page then the scroll button appears
    if (
      document.body.scrollTop > 30 ||
      document.documentElement.scrollTop > 30
    ) {
      mybutton.style.display = "block";
    } else {
      mybutton.style.display = "none";
    }
  }

  function backToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  return (
    <MDBContainer fluid>
      <MDBBtn
        onClick={backToTop}
        id="btn-back-to-top"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          display: "none",
          zIndex: 2,
        }}
        className="btn-floating"
        color="danger"
        size="lg"
      >
        <MDBIcon fas icon="arrow-up" />
      </MDBBtn>
    </MDBContainer>
  );
};

export default Scroll;
